/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContentView
 */
export interface ContentView {
    /**
     * 
     * @type {string}
     * @memberof ContentView
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof ContentView
     */
    currentVersion: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContentView
     */
    versions: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ContentView
     */
    pageName: string;
}

/**
 * Check if a given object implements the ContentView interface.
 */
export function instanceOfContentView(value: object): value is ContentView {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('currentVersion' in value) || value['currentVersion'] === undefined) return false;
    if (!('versions' in value) || value['versions'] === undefined) return false;
    if (!('pageName' in value) || value['pageName'] === undefined) return false;
    return true;
}

export function ContentViewFromJSON(json: any): ContentView {
    return ContentViewFromJSONTyped(json, false);
}

export function ContentViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentView {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
        'currentVersion': json['currentVersion'],
        'versions': json['versions'],
        'pageName': json['pageName'],
    };
}

export function ContentViewToJSON(value?: ContentView | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'content': value['content'],
        'currentVersion': value['currentVersion'],
        'versions': value['versions'],
        'pageName': value['pageName'],
    };
}

